import {WicketAdminAudienceFilterOperator} from '../wicket-admin-audience-filter-rule';

export interface WicketAdminAudienceFilterData {
  id: number;
  name: string;
  display_name: string;
  type: FilterDataType;
  data_values: string[] | [true, false] | null;
}

export type FilterDataType = 'enum' | 'string' | 'integer' | 'date' | 'boolean';

export interface WicketAdminUserDataApiFilter {
  data_type_id: number;
  operator: WicketAdminAudienceFilterOperator;
  value: string | number | boolean;
  name?: string;
}

export interface WicketAdminUserFilter {
  userData: WicketAdminAudienceFilterData | null;
  operator: WicketAdminAudienceFilterOperator | null;
  value?: string | number | boolean;
}

export interface WicketAdminUserApiFilter {
  user_data_filters: WicketAdminUserDataApiFilter[] | null;
  user_agreement_filters: number[] | null;
  user_agreement_condition: WicketAdminUserFilterCondition;
  user_application_filters: number[] | null;
  user_application_condition: WicketAdminUserFilterCondition;
}

export enum WicketAdminUserFilterCondition {
  ANY = 'any',
  ALL = 'all',
}
